<script>
    import { getContext } from "svelte";
    import sustainabilityLabelClickTracker from "../tracking/sustainabilityLabelClickTracker";
    import { key as svgImageUrlPrefixCtxKey } from "../context/svgImageUrlPrefix";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let { labels, cinemaId, variationId, baseDetailViewUrl, variationDetailViewUrl, cinemaTracking } = $props();
    const textLink = "Mehr erfahren";
    let dataSheetMenuContent = `<oc-button-v1 base64-href=${btoa(variationDetailViewUrl)} size="100" fill-parent="" variant="primary"><a href=${baseDetailViewUrl}>${textLink}</a></oc-button-v1>`;

    const svgImageUrlPrefix = getContext(svgImageUrlPrefixCtxKey);

    const clickHandler = (event) => {
        const iconContainer = event.target.closest("[data-sustainability-tag]");
        if (iconContainer === null) {
            return;
        }
        sustainabilityLabelClickTracker({
            variationId,
            cinemaType: cinemaTracking.name,
            sustainabilityTag: iconContainer.dataset.sustainabilityTag,
        });
    };
</script>

{#if Array.isArray(labels) && labels.length >= 1}
    <div class="reco_cinema__multi-sustainabilities-container oc-mt-50">
        {#each labels as label}
            <!--svelte-ignore a11y_consider_explicit_label-->
            <button
                class="reco_cinema__multi-sustainabilities-container-icon-wrapper js_openInPaliSheet"
                data-sheet-title="Was bedeutet dieses Zeichen?"
                data-sheet-url={svgImageUrlPrefix + label.descriptionUrl}
                data-sheet-menu-content={dataSheetMenuContent}
                data-sustainability-tag={label.tag}
                data-sheet-id={`${cinemaId}|${variationId}|${label.icon}`}
                onclick={clickHandler}
            >
                <svg class="pl_icon" role="img">
                    <use href={`${svgImageUrlPrefix}/assets-static/icons/` + label.icon + ".svg#" + label.icon} />
                </svg>
            </button>
        {/each}
    </div>
{/if}

<style lang="scss">
    .reco_cinema__multi-sustainabilities-container {
        display: flex;
        flex-wrap: wrap;

        &-icon-wrapper {
            width: 32px;
            height: 32px;
            margin-right: 4px;
            background-color: $pl_color-sustainable;
            border-radius: 50%;
            display: flex;
            align-items: center;
            border: 0;
            padding: 0 0 0 4px;

            svg {
                width: 24px;
                height: 24px;
                fill: #fff;
                cursor: pointer;
            }
        }
    }
</style>
